import { IconType } from '@react-icons/all-files/lib';
import { createContext } from 'react'

const IconsContext = createContext(
  new Map<string, { icon: IconType; scale: number }>()
)

export default IconsContext
